import React from "react";
import { withStyles } from "material-ui/styles";

import { Button } from "material-ui";
import { fade } from "material-ui/styles/colorManipulator";
import PreviewModalContainer from "containers/CreateSurvey/PreviewModalContainer";
import Icon from "material-ui/Icon";
import { isAdmin, charcount } from "utils/formatter";

import CInput from "uis/CInput";

const styles = theme => ({
  removeButton: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
    }
  },
  paperTitle: {
    color: "#575962",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600,
    marginLeft: 10
  },
  paperRow: {
    marginBottom: 15
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300,
    marginBottom: 5
  },
  paperValue: {
    color: "#575962",
    marginTop: "0.1rem",
    marginLeft: "2rem",
    display: "inline-block",
    fontSize: "1.1rem",
    fontWeight: 600
  },
  addButton: {
    border: "1px dashed gray",
    padding: "2px 0",
    textAlign: "center",
    width: 510,
    marginBottom: ".5rem",
    backgroundColor: "white",
    cursor: "pointer",
    outline: "none",
    "&:hover": {
      backgroundColor: fade("#26a69a", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }
});

const QuestionSettingPanel = props => {
  const { classes, items, selectedItemId, localeNo } = props;
  const item =
    items[localeNo] &&
    items[localeNo].filter(i => i.id - selectedItemId === 0)[0];
  return (
    <div
      style={{
        position: "relative",
        height: "100%"
      }}
    >
      <div style={{ backgroundColor: "#f4f5f8", padding: "5px 10px" }}>
        <div className={classes.paperTitle}>設問</div>
        {selectedItemId !== 0 && (
          <Button
            className={classes.removeButton}
            dense
            raised
            disabled={selectedItemId === 0 || !props.isEdit}
            style={{ float: "right" }}
            onClick={() => props.removeItem(selectedItemId)}
          >
            設問削除
          </Button>
        )}
      </div>
      <div style={{ padding: 10 }}>
        {selectedItemId === 0 ? (
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              textAlign: "center",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "1.7rem",
              fontWeight: 600
            }}
          >
            {props.isEdit && parseInt(props.additionLimit, 10) > 0
              ? "左の＋（追加）ボタンから設問を追加できます。"
              : ""}
          </div>
        ) : (
          <div>
            <div>
              <div className={classes.paperDesc} style={{ marginBottom: 0 }}>
                設問文*
              </div>
            </div>
            <div
              className={classes.paperPeriod}
              style={{ marginLeft: 0, width: "100%" }}
            >
              <CInput
                value={(item && item.content) || ""}
                multiline
                fullWidth
                rows="4"
                disabled={selectedItemId === 0 || !props.isEdit}
                onChange={e => {
                  if (charcount(e.target.value) > 165) return;
                  props.changeItem("content", e.target.value);
                }}
              />
            </div>
            <div style={{ width: "100%" }}>
              <div
                className={classes.paperDesc}
                style={{ width: 490, display: "inline-block" }}
              >
                回答（選択肢）
              </div>
              {isAdmin() && (
                <Button
                  dense
                  raised
                  disabled={selectedItemId === 0 || !props.isEdit}
                  style={{ marginLeft: 10, marginRight: 10 }}
                  onClick={props.setPtReverse}
                >
                  ポイント反転
                </Button>
              )}
            </div>
            <div style={{ height: 170, marginLeft: 30, marginTop: 5 }}>
              {isAdmin() ? (
                <div>
                  {item &&
                    item.choices.map((choice, index) => (
                      <div style={{ marginBottom: 5 }} key={choice.id}>
                        <div
                          className={classes.paperDesc}
                          style={{ width: 20, display: "inline-block" }}
                        >
                          {index + 1}.
                        </div>
                        <CInput
                          style={{ marginLeft: 20, width: 400 }}
                          value={choice.name}
                          disabled={selectedItemId === 0 || !props.isEdit}
                          onChange={e =>
                            props.changeAnswer(index, e.target.value)
                          }
                          inputProps={{
                            maxLength: 30
                          }}
                        />
                        <div
                          className={classes.paperDesc}
                          style={{
                            marginLeft: 20,
                            width: 80,
                            display: "inline-block"
                          }}
                        >
                          {item.reverse
                            ? index + 1
                            : item.choices.length - index}ポイント
                        </div>
                        <Button
                          dense
                          raised
                          disabled={selectedItemId === 0 || !props.isEdit}
                          style={{
                            marginLeft: 20,
                            minWidth: 40
                          }}
                          onClick={() => props.removeAnswer(index)}
                        >
                          ✕
                        </Button>
                      </div>
                    ))}
                  {item &&
                    item.choices.length < 5 &&
                    props.isEdit && (
                      <div
                        role="button"
                        id="addButton"
                        tabIndex={0}
                        onClick={props.addNewAnswer}
                        onKeyPress={props.addNewAnswer}
                        className={classes.addButton}
                      >
                        <Icon style={{ verticalAlign: "sub", fontSize: 20 }}>
                          add
                        </Icon>
                        <span>（追加）</span>
                      </div>
                    )}
                </div>
              ) : (
                <div>
                  {item &&
                    item.choices.map((choice, index) => (
                      <div
                        style={{ marginBottom: 5, marginTop: 5 }}
                        key={choice.id}
                      >
                        <div
                          className={classes.paperDesc}
                          style={{ width: 20, display: "inline-block" }}
                        >
                          {index + 1}.
                        </div>
                        <div
                          style={{
                            marginLeft: 20,
                            width: 400,
                            display: "inline-block"
                          }}
                        >
                          {choice.name}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {selectedItemId !== 0 && (
        <div
          style={{
            position: "absolute",
            right: 0,
            bottom: 0,
            margin: "5px 12px"
          }}
        >
          <Button
            disabled={selectedItemId === 0 || !props.isEdit}
            dense
            raised
            onClick={() =>
              props.openPreviewModal(
                localeNo,
                selectedItemId,
                items,
                item.choices
              )
            }
          >
            追加設問プレビュー
          </Button>
          <PreviewModalContainer />
        </div>
      )}
    </div>
  );
};
export default withStyles(styles)(QuestionSettingPanel);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/Additions/QuestionSettingPanel.jsx